import React, { useState } from "react";

const Categories = () => {
  const [categories] = useState([
    { id: 1, name: "Web Design", image: "img/cat-1.jpg", courses: 49 },
    { id: 2, name: "Graphic Design", image: "img/cat-2.jpg", courses: 49 },
    { id: 3, name: "Video Editing", image: "img/cat-3.jpg", courses: 49 },
    { id: 4, name: "Online Marketing", image: "img/cat-4.jpg", courses: 49 },
  ]);

  return (
    <div className="container-xxl py-5 category">
      <div className="container">
        <div className="text-center wow fadeInUp" data-wow-delay="0.1s">
          <h6 className="section-title bg-white text-center text-primary px-3">
            Categories
          </h6>
          <h1 className="mb-5">Courses Categories</h1>
        </div>
        <div className="row g-3">
          {categories.map((category, index) => (
            <div
              key={category.id}
              className={`col-lg-${index < 3 ? "7" : "5"} col-md-6 wow zoomIn`}
              data-wow-delay={`${0.1 * (index + 1)}s`}
            >
              <a className="position-relative d-block overflow-hidden" href="">
                <img
                  className="img-fluid"
                  src={category.image}
                  alt={category.name}
                />
                <div
                  className="bg-white text-center position-absolute bottom-0 end-0 py-2 px-3"
                  style={{ margin: "1px" }}
                >
                  <h5 className="m-0">{category.name}</h5>
                  <small className="text-primary">
                    {category.courses} Courses
                  </small>
                </div>
              </a>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Categories;
